import { Tournament } from 'functions/src/types/firestore/Game/Tournament';

export const toCheckInProps = (
  tournament: Tournament<Date>,
  userIdActive?: string,
) => {
  if (!userIdActive) {
    return;
  }
  const {
    tournamentDetails,
    guestlistAggregated,
    id: tournamentId,
    prize,
    title,
    date,
    gameId,
    gameTitle,
    readyTime,
    skipCheckIn,
  } = tournament;

  const detail = tournamentDetails?.find((tournamentDetail) => {
    return tournamentDetail.title === 'Rules And Regulations';
  });
  const rulesAndRegs = detail ? detail.body : undefined;
  const allTeam = guestlistAggregated.filter((team) => {
    return team.acceptedUserIds.includes(userIdActive);
  })[0];
  const participant = allTeam.members.filter((member) => {
    return member.userId === userIdActive;
  })[0];
  const teammates = allTeam.members.filter((member) => {
    return member.userId !== userIdActive;
  });

  return {
    tournamentId,
    prize,
    title,
    date,
    gameId,
    gameTitle,
    readyTime,
    skipCheckIn,
    rulesAndRegulations: rulesAndRegs,
    isCaptain: participant.status === 'captain',
    teamId: allTeam.id,
    teammates: teammates,
    checkedIn: participant.checkedIn,
  };
};
